import { CATEGORY_PAGE_CONTAINER_NAME } from "@faire/retailer-shared/categories/createRequests/__internal__/CATEGORY_PAGE_CONTAINER_NAME";
import { IPaginationData } from "@faire/web-api--source/indigofair/data/IPaginationData";
import { IProductFirstCatNavRequest } from "@faire/web-api--source/indigofair/data/IProductFirstCatNavRequest";
export var buildCatNavProductsRequest = function(param) {
    var navigationPath = param.navigationPath, filterKeys = param.filterKeys, pageSize = param.pageSize, pageNumber = param.pageNumber, shouldRequestRetrievalRankingDebugInfo = param.shouldRequestRetrievalRankingDebugInfo, requestReferrer = param.requestReferrer;
    return IProductFirstCatNavRequest.build({
        navigation_path: navigationPath,
        filter_keys: filterKeys,
        container_name: CATEGORY_PAGE_CONTAINER_NAME,
        pagination_data: IPaginationData.build({
            page_number: pageNumber,
            page_size: pageSize
        }),
        referrer: requestReferrer,
        return_retrieval_and_ranking_debug_info: shouldRequestRetrievalRankingDebugInfo
    });
};
